import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  Backdrop,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function LogoutModal({ open, handleClose }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    setLoading(true);
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));

      await axios.post(
        "https://tarabotcs.com-eg.net/api/Users/V1/Logout",
        {},
        {
          headers: {
            CompanyID: userData?.Data?.CompanyID,
            AccessToken: userData?.Data?.AccessToken,
          },
        }
      );
    } catch (error) {
      // إذا كانت حالة الرد 401 Unauthorized
      if (error.response && error.response.status === 401) {
        console.log("Session expired, logging out...");
      } else {
        console.error("Error logging out:", error);
      }
    } finally {
      localStorage.removeItem("userData");
      navigate("/");
      setLoading(false);
    }
  };

  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle
          sx={{
            textAlign: "center",
            fontSize: "22px",
            color: "#263150",
            fontWeight: "bold",
          }}
        >
          {t("confirmLogOut")}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{ textAlign: "center", marginBottom: 2 }}
          >
            {t("areYouSureWantToLogOut")}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center", gap: 1.5, pb: 2 }}>
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{
              borderColor: "#cbd5e1",
              color: "#64748b",
              borderRadius: "8px",
              px: 3,
              fontWeight: 600,
              "&:hover": { borderColor: "#94a3b8", backgroundColor: "#f8fafc" },
            }}
            disabled={loading}
          >
            {t("cancel")}
          </Button>
          <Button
            onClick={handleLogout}
            variant="contained"
            sx={{
              backgroundColor: "#ef4444",
              color: "white",
              borderRadius: "8px",
              px: 3,
              fontWeight: 700,
              "&:hover": { backgroundColor: "#dc2626" },
            }}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              t("confirm")
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
